var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"错误对照","name":"one"}},[_c('ComWrong')],1),_c('el-tab-pane',{attrs:{"label":"敏感词","name":"two"}},[_c('ComBlackWord')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }